import { EMOJI_ALIASES } from './emojiAliases';

/** Minuscules, sans accents ni ligatures (cœur → coeur), apostrophe typographique ramenée à l'apostrophe simple. */
function normalize(text: string): string {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/œ/g, 'oe')
    .replace(/æ/g, 'ae')
    .replace(/’/g, "'");
}

const NORMALIZED_ALIASES = new Map(
  Object.entries(EMOJI_ALIASES).map(([emoji, alias]) => [emoji, normalize(alias)]),
);

/**
 * Emojis dont les noms français contiennent chaque mot tapé (« joie », « pouce haut »).
 * L'ordre du catalogue est conservé. Une recherche vide ne renvoie rien.
 */
export function searchEmojis(query: string, catalogue: readonly string[]): string[] {
  const words = normalize(query).split(/\s+/).filter(Boolean);
  if (words.length === 0) return [];
  return catalogue.filter((emoji) => {
    const alias = NORMALIZED_ALIASES.get(emoji);
    return !!alias && words.every((word) => alias.includes(word));
  });
}
